import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Icon from '@components/common/assets';
import { FindStateType, LoginJoin, LoginForm, ModalStateType, SocialLogin } from '@components/loginModal';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useInsightAceessToken } from '@repository/insight/useInsight';
import Title from '@components/jobflexLoginModal/login/title';
import { JobflexQueryType } from '@domain/constant/JobflexQueryType';
import classnames from 'classnames/bind';
import styles from './myPageLogin.module.scss';

const cx = classnames.bind(styles);

const LoginJobflex = () => {
  const router = useRouter();
  const {
    query: { messageUrl },
  } = router;

  const handleClick = () => {
    if (!window || !window.opener) return;
    window.opener.postMessage({ isJobdaClose: true }, `${messageUrl}`);
  };

  return (
    <div className={cx('loginInfo')} onClick={handleClick}>
      <span className={cx('description')}>
        <Icon name="informationLight" width={18} height={18} /> 잡다 로그인 없이 성명, 이메일, 지원서 비밀번호만
        입력하여도 마이페이지 확인이 가능합니다.
      </span>
    </div>
  );
};

interface MyPageLoginProps {
  setModalState: (state: ModalStateType) => void;
  setFindState: (state: FindStateType) => void;
}

const MyPageLogin = ({ setModalState, setFindState }: MyPageLoginProps) => {
  const router = useRouter();
  const { asPath } = router;
  const {
    query: { type, messageUrl },
  } = router;

  const { data: userInfo } = useUserInfo();
  const { mutateAsync: fetchInsightAccessToken } = useInsightAceessToken();
  const isLogin = !!userInfo?.id;
  const isChangePassword = userInfo?.authorities.includes('PASSWORD_CHANGE_REQUIRED');
  /* 잡플렉스 마이페이지 로그인*/
  const sendJobFlexMypage = async () => {
    if (!window || !window.opener) return;
    const { accessToken } = await fetchInsightAccessToken();
    window.opener.postMessage({ accessToken }, `${messageUrl}`);
  };

  const getQuery = () => {
    if (!type) return null;
    return {
      type: type as JobflexQueryType,
    };
  };

  useEffect(() => {
    if (isLogin && !isChangePassword) sendJobFlexMypage();
  }, [isLogin]);

  return (
    <div className={cx('myPageLogin')}>
      <Title />

      <div className={cx('formWrap')}>
        <LoginForm setFindState={setFindState} setModalState={setModalState} visibleJoinButton={false} />
        <SocialLogin type={'MODAL'} redirectUrl={asPath} />
        <LoginJoin label={<>회원가입</>} query={getQuery()} />
      </div>
      <LoginJobflex />
    </div>
  );
};

export default MyPageLogin;
